// CaseTempo design system status colors (rose, mint, sun, sky, ...). One per case state, in order.
export const colors = [
    '#e399a3',
    '#72c591',
    '#cfb64f',
    '#8bb0df',
    '#d89e6e',
    '#c8a8e7',
    '#56bac9',
    '#de98bc',
    '#a1c764',
    '#f4bdc4',
    '#59b7ab',
    '#dcc4f7',
    '#cdbaa5',
    '#f4e8b8',
    '#ce9690',
    '#aeeac3',
    '#c1c3a4',
    '#f0ca9e',
    '#9aa9ed',
    '#bec8d4',
    '#5b6676',
];

export const colorMap = {
    'red': '230, 25, 75',
    'green': '60, 180, 75',
    'yellow': '255, 225, 25',
    'blue': '0, 130, 200',
    'orange': '245, 130, 48',
    'purple': '145, 30, 180',
    'cyan': '70, 240, 240',
    'magenta': '240, 50, 230',
    'lime': '210, 245, 60',
    'pink': '250, 190, 190',
    'teal': '0, 128, 128',
    'lavender': '230, 190, 255',
    'brown': '170, 110, 40',
    'beige': '255, 250, 200',
    'maroon': '128, 0, 0',
    'mint': '170, 255, 195',
    'olive': '128, 128, 0',
    'coral': '255, 215, 180',
    'navy': '0, 0, 128',
    'grey': '128, 128, 128',
    'white': '255, 255, 255',
    'black': '0, 0, 0',
};

export const getCaseStateColor = (caseState, config) => {
    let caseStates = (config && config['caseStates']) || [];
    let index = caseStates.findIndex(v => v.type === caseState);
    if (index >= 0) {
        return colors[index % colors.length];
    }

    return '#FFF';
};

export const getTemplateFinderColor = (card, config=undefined, opacity=0.7) => {
    switch (card.value) {
    case 'documents':
        return `rgba(${colorMap['lavender']}, ${opacity})`;
    case 'doc_templates':
        return `rgba(${colorMap['olive']}, ${opacity})`;
    case 'email_templates':
        return `rgba(${colorMap['yellow']}, ${opacity})`;
    case 'sms_templates':
        return `rgba(${colorMap['blue']}, ${opacity})`;
    default:
        break;
    }

    return '#FFF';
};

export const dialogHeaderFooterBgColor = '#E9EBEC';
export const errorBackgroundColor = 'rgb(249,189,187)';
export const warningBackgroundColor = 'rgba(255, 225, 25, 0.5)';
export const privateFormFieldColor = 'rgba(145, 30, 180, 1.0)';
export const sectionFormFieldColor = 'rgba(0, 130, 200, 0.3)';
export const requiredFormFieldColor = 'rgb(229, 28, 35)';
export const placeholderPillColor = 'rgb(211,225,235)';
export const deletedRowColor = 'rgba(0, 0, 0, 0.3)';
